import { Alert, Stack } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { StackInIssueCheckResponse } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { getStackInWarningPresentations } from '../utils/imdg-stack-in-warning-presentation.util'

interface Props {
  warnings: StackInIssueCheckResponse[]
}
export const YardSelectorWarning = observer(({ warnings }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const alerts = useMemo(
    () => getStackInWarningPresentations(warnings).map(({ key, fallback, severity }) => ({
      message: t(key, fallback),
      severity,
    })),
    [t, warnings],
  )

  return (
    <Stack spacing={theme.customSpacing.s}>
      {alerts.map((alert, index) => (
        <Alert key={'warning-' + index} severity={alert.severity}>
          {alert.message}
        </Alert>
      ))}
    </Stack>
  )
})
